import React, { useState } from 'react';
import { app, auth } from '../firebase';
import { signInWithCustomToken } from 'firebase/auth';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { enablePanelSessionPersistence } from '../utils/panelSession';

function LoginPage() {
  const [mobile, setMobile] = useState('');
  const [pin, setPin] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const functions = getFunctions(app, "asia-south1");

  const handleLogin = async () => {
    setLoading(true);
    try {
      const call = httpsCallable(functions, "panelLogin");
      const res = await call({
        mobile: String(mobile || "").replace(/\D/g, ""),
        pin: String(pin || "").trim(),
      });
      const payload = res?.data || {};
      if (!payload?.ok || !payload?.customToken || !payload?.employee) {
        throw new Error("Invalid credentials or inactive account.");
      }

      await enablePanelSessionPersistence();
      await signInWithCustomToken(auth, payload.customToken);

      const userWithPerms = {
        ...payload.employee,
        sessionStartedAt: new Date().toISOString(),
      };
      localStorage.setItem("employee", JSON.stringify(userWithPerms));

      toast.success(`Welcome ${payload.employee.name || "Admin"}!`, {
        position: "top-center",
        autoClose: 2000,
      });

      setTimeout(() => {
        navigate('/panel/dashboard');
      }, 2000);
    } catch (err) {
      console.error("Login error:", err);
      toast.error(err?.message || "Something went wrong. Please try again.", {
        position: "top-center",
        autoClose: 3000,
      });
    }
    setLoading(false);
  };

  return (
    <div
      style={{
        background: `
          linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.7)),
          url('https://images.unsplash.com/photo-1470770841072-f978cf4d019e?auto=format&fit=crop&w=1650&q=80')
        `,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '100vh',
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <h1 style={{
        color: '#ffffff',
        fontSize: '2rem',
        marginBottom: '2rem',
        textShadow: '0 2px 6px rgba(0,0,0,0.5)',
        fontWeight: 'bold'
      }}>
        Welcome to ApnaArtist
      </h1>

      <div style={{
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        padding: '2rem',
        width: '90%',
        maxWidth: '400px',
        boxShadow: '0 8px 20px rgba(0,0,0,0.2)',
        textAlign: 'center'
      }}>
        <h2 style={{
          marginBottom: '1.5rem',
          fontSize: '1.5rem',
          color: '#e91e63'
        }}>
          Admin Login
        </h2>

        <input
          type="text"
          placeholder="Mobile Number"
          value={mobile}
          onChange={(e) => setMobile(e.target.value)}
          style={{
            width: '100%',
            padding: '0.75rem',
            marginBottom: '1rem',
            borderRadius: '6px',
            border: '1px solid #ccc'
          }}
        />

        <input
          type="password"
          placeholder="6-digit PIN"
          value={pin}
          onChange={(e) => setPin(e.target.value)}
          style={{
            width: '100%',
            padding: '0.75rem',
            marginBottom: '1.5rem',
            borderRadius: '6px',
            border: '1px solid #ccc'
          }}
        />

        <button
          onClick={handleLogin}
          disabled={loading}
          style={{
            width: '100%',
            padding: '0.75rem',
            backgroundColor: loading ? '#aaa' : '#e91e63',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            fontWeight: 'bold',
            cursor: loading ? 'not-allowed' : 'pointer'
          }}
        >
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </div>

      <ToastContainer />
    </div>
  );
}

export default LoginPage;
